import { useMutation } from 'src/core/api/hooks/useMutation';

type Payload = {
  user_id: string;
  endpointParams: {
    groupId: string;
  };
};

export const useCreateTeamMutation = () => {
  return useMutation<Payload>({
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: ({ groupId }) => `/groups/${groupId}/users`,
      method: 'post',
    },
    options: {
      throwOnError: true,
    },
  });
};
